import {Component} from "@angular/core";
import {MessageNotificationDto} from "@resources/resources";
import {AsiDialogView} from "@asi-ngtools/lib";

@Component({
  selector: 'dialog-detail-notification',
  templateUrl: './dialog-detail-notification.component.html'
})
export class DetailNotificationDialog extends AsiDialogView {

  notification: MessageNotificationDto;

  constructor() {
    super();
  }

  public hasUrl(): boolean {
    return this.notification != null && this.notification.url != null;
  }

  public openUrl(): void {
    if (this.notification.url.startsWith("http://") || this.notification.url.startsWith("https://")) {
      window.open(this.notification.url);
    } else {
      window.open("http://" + this.notification.url);
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/common/utils/dialog/dialog-detail-notification.component.ts